import $ from 'jquery'
import Cookies from 'js-cookie'
import { actionTypes } from '../constants'

export const pageHeaderHeightWasSet = pageHeaderHeight => ({
  payload: {
    pageHeaderHeight,
  },
  type: actionTypes.PAGE_HEADER_HEIGHT_WAS_SET,
})

export const retainState = () => (dispatch, getState) => {
  const state = getState()
  Cookies.set('pathnameSearch', `${state.app.pathname}${state.app.search}`)
  Cookies.set('y', state.app.y)
  dispatch({
    type: actionTypes.STATE_WAS_RETAINED,
  })
}

export const setLastProjectsUrl = (pathname, search) => ({
  payload: {
    pathname,
    search,
  },
  type: actionTypes.LAST_PROJECTS_URL_WAS_SET,
})

export const windowWasScrolled = (y, verticalSpeed) => (dispatch, getState) => {
  const state = getState()
  if (verticalSpeed < -10) {
    dispatch({
      type: actionTypes.WINDOW_IS_ON_UPSWING,
    })
    $('header').removeClass('is-hidden').addClass('is-stuck')
  }
  if (verticalSpeed > 0) {
    dispatch({
      type: actionTypes.WINDOW_IS_ON_DOWNSWING,
    })
    if (y >= state.app.pageHeaderHeight) {
      $('header').addClass('is-hidden')
    }
    $('header').removeClass('is-stuck')
  }
  if (y <= 0) {
    $('header').removeClass('is-stuck').removeClass('is-hidden')
  }
  dispatch({
    payload: {
      y,
    },
    type: actionTypes.WINDOW_WAS_SCROLLED,
  })
}
